import React, { useEffect, useState } from 'react';
import LoaderNew from '../../../common/LoaderNew';
import Node from '../../../common/Node';
import EventByPredicate from './EventByPredicate';
import InfiniteScroll from 'react-infinite-scroll-component';
import { VALUE_EXPRESSION } from '../EventsPage';


export default ({
    events,
    classes,
    nodesData,
    filterByPids,
    filterByConcept,
    filteredEventIds,
    areThereAnyEventsByCid,
}) => {

  const [items, setItems] = useState(25);

  useEffect(() => {
    setItems(25);
  }, [filterByConcept, filterByPids]);

  const fetchMoreData = () => {
    setTimeout(() => {
      setItems(items + 25);
    }, 100);
  };

  const getEventsChunk = () => {
    const res = {};
    let count = 0;
    for (const conceptId of Object.keys(events)) {
      if (count >= items) break;

      let eventsByCid = events[conceptId];
      if (filteredEventIds) {
        eventsByCid = eventsByCid.filter(e => filteredEventIds[VALUE_EXPRESSION].includes(e.id));
      }

      if (count + eventsByCid.length <= items) {
        res[conceptId] = eventsByCid;
        count += eventsByCid.length;
      } else {
        res[conceptId] = eventsByCid.slice(0, (items - count));
        count += (items - count);
      }
    }
    return res;
  };

  const eventsChunk = getEventsChunk();
  const hasMoreData = Object.keys(events).length > Object.keys(eventsChunk).length;

  return (
    <InfiniteScroll
      dataLength={items}
      next={fetchMoreData}
      hasMore={hasMoreData}
      loader={
        hasMoreData &&
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
          <LoaderNew />
        </div>
      }
      style={{overflow: 'hidden'}}
    >
      {Object.keys(eventsChunk).map((conceptId) => {
        if (filteredEventIds && !areThereAnyEventsByCid(VALUE_EXPRESSION, conceptId)) return null;

        const node = nodesData[conceptId];

        if (filterByConcept && Number(conceptId) !== filterByConcept.id) return null;

        return (
          <div key={conceptId}>
            <div>
              <Node size="sm" isLink node={node} className={classes.mt20} />

              <div className={classes.headingContainer}>
                <div className={classes.predIdsCol}>
                  <span className={classes.columnHeadingGeneral}>Id</span>
                </div>

                <div className={classes.predSubsCol}>
                  <span className={classes.columnHeadingGeneral}>Subscribers</span>
                </div>

                <div className={classes.predEventCell}>
                  <span className={classes.columnHeadingGeneral}>Event</span>
                </div>

                <div className={classes.predSubCell}>
                  <span className={classes.columnHeadingGeneral}>Subscription</span>
                </div>

                <div className={classes.predScriptCell}>
                  <span className={classes.columnHeadingGeneral}>Script (Function)</span>
                </div>
              </div>

              {eventsChunk[conceptId].map((sub, subIndex) => {
                return (
                  <EventByPredicate
                    key={subIndex}
                    sub={sub}
                    subIndex={subIndex}
                    ancestor={conceptId}
                    ValueExpression={true}
                  />
                );
              })}

            </div>
          </div>
        )
      })}
    </InfiniteScroll>
  );
};